module.exports = __webpack_public_path__ + "static/media/tracey-5.7e861ff7.wav";